export function getErrorString(error) {
    if (!error) {
        return '';
    }
    if (typeof error === 'string') {
        return error;
    }
    return "name: ".concat(error.name, ". code: ").concat(error.errorCode, ". message: ").concat(error.errorMessage, ". subError: ").concat(error.subError, ". correlationId: ").concat(error.correlationId);
}
//# sourceMappingURL=getErrorString.js.map